import { dialogContentClasses } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useCodeExampleModalStyles = makeStyles()(theme => ({
  snippetsDialogPaper: {
    width: 600,

    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(4),
      padding: theme.spacing(4),
    },

    [`.${dialogContentClasses.root}`]: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
    },
  },
  snippetsDialogTitle: {
    marginBottom: theme.spacing(8),

    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(4),
    },
  },
  chainDescription: {
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(3, 5),
  },
  codeExampleModalChainLogo: {
    backgroundColor: theme.palette.background.default,
    borderRadius: '50%',
    width: 32,
    height: 32,
    marginRight: theme.spacing(3),
  },
  chainSelectorControls: {
    borderBottom: 'none',
    marginTop: theme.spacing(3),
    paddingBottom: 0,
    '& div': {
      width: '100%',
      display: 'flex',
    },
  },
  chainSelectorContent: {
    '&&': {
      width: '100%',
      flexWrap: 'wrap',
    },
  },
  tabsInner: {
    overflowX: 'auto',

    '&::-webkit-scrollbar': {
      width: 3,
      height: 3,
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.grey[300],
      borderRadius: 2,
    },
  },
}));
